export function mapIdentifierList(node, ctx) {
    const columns = [];
    const listNode = ctx.getChild(node, "IdentifierList");
    if (listNode) {
        const identifiers = ctx.getChildren(listNode, "Identifier");
        for (const ident of identifiers) {
            columns.push(ctx.slice(ident));
        }
    }
    return columns;
}
